<script lang="ts">
  import translationsStore from '../../../stores/translations.svelte'
  import videoStore from '../../../stores/video.svelte'
  import FullScreenPopup from '../FullScreenPopup.svelte'

  let summary = $derived(videoStore.state.currentSummary)

  function onClose() {
    if (videoStore.state.wasPlayingWhenSummaryOpened) {
      videoStore.state.videoController?.play()
    }
    videoStore.setCurrentSummary(null)
  }
</script>

<FullScreenPopup onclose={() => onClose()}>
  {#if summary?.title}
    <h2 class="pmd:text-2xl text-lg font-bold">{summary?.title}</h2>
  {/if}
  {#if summary?.abstract}<p class="pmd:text-lg text-sm my-6">
      {summary?.abstract}
    </p>{/if}
  {#if summary?.takeaways && summary?.takeaways.length}
    <p class="pmd:text-lg text-sm font-semibold my-2">
      {translationsStore.get('take_aways', summary?.language)}
    </p>
    <ul class="pmd:text-lg text-sm list-disc pl-4">
      {#each summary?.takeaways || [] as takeaway}
        <li>{takeaway}</li>
      {/each}
    </ul>
  {/if}
</FullScreenPopup>
